module.exports = __webpack_public_path__ + "static/media/print-blue.f8db4c85.svg";